import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/api";

export default function WhatsAppFloat() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-button"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 group"
      aria-label="Enquire on WhatsApp"
    >
      <div className="flex items-center gap-3 bg-[#1B3B36] text-[#F9F8F6] pl-4 pr-5 py-3 shadow-[0_10px_30px_-8px_rgba(27,59,54,0.5)] hover:bg-[#132A26] transition-colors">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#84968C] opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-[#84968C]"></span>
        </span>
        <MessageCircle size={16} />
        <span className="text-[12px] tracking-[0.18em] uppercase font-medium hidden sm:inline">
          Enquire on WhatsApp
        </span>
        <span className="text-[12px] tracking-[0.18em] uppercase font-medium sm:hidden">
          Chat
        </span>
      </div>
    </a>
  );
}
